import { render, staticRenderFns } from "./modelOfContract.vue?vue&type=template&id=7652d2d4&scoped=true"
import script from "./modelOfContract.vue?vue&type=script&lang=js"
export * from "./modelOfContract.vue?vue&type=script&lang=js"
import style0 from "./modelOfContract.vue?vue&type=style&index=0&id=7652d2d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652d2d4",
  null
  
)

export default component.exports